import { render, staticRenderFns } from "./PaymentError.vue?vue&type=template&id=30c609a2&scoped=true&"
import script from "./PaymentError.vue?vue&type=script&lang=js&"
export * from "./PaymentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c609a2",
  null
  
)

export default component.exports